<contacts-list *ngIf="!params.readOnly || (fieldValue?.length > 0)" [params]="params" [model]="fieldValue"
	(modelChange)="onModelChanged($event)">
</contacts-list>